import { Component, OnInit } from '@angular/core';
import { Router, NavigationEnd, NavigationStart, RouteConfigLoadStart, RouteConfigLoadEnd } from '@angular/router';
//import {ToastComponent} from "../../shared/toast/toast.component";
import * as moment from 'moment';
//import * as _ from 'lodash';
import { Cookie } from 'ng2-cookies';
import { HttpClient, HttpHeaders } from '@angular/common/http';
import { TeacherDashService } from './services/teacher-dash.service';
import { AuthService } from '../../shared/services/auth.service';
import { TokenStorageService } from '../../shared/services/token-storage.service';
import { User } from '../../models/user.model';
import { Staff } from 'src/app/models/staff.model';

@Component({
  selector: 'app-teacher-dash',
  templateUrl: './teacher-dashboard.component.html',
  styleUrls: ['./teacher-dashboard.component.scss']
})
export class TeacherDashComponent implements OnInit {

  title = 'teacher-dash';
  staffDetail: Staff;

  constructor(private router: Router, private _http: HttpClient,
              private teacherDashService: TeacherDashService,
              private authService: AuthService, private tokenStorageService: TokenStorageService) { }

  ngOnInit() {
    console.log('--inside  TeacherDashComponent- ngOnInit----');
    //this.getUserProfile();
    this.saveUserData();
    //this.testMethod();
  }

  saveUserData(){
    console.log('>>>>>saveUserData-Teacher>>>>> ')
    const userData: User = {
      userName: this.tokenStorageService.getUser(),userRole: this.tokenStorageService.getUserRole(),
      clientName: this.tokenStorageService.getTenantName(), branchCode: this.tokenStorageService.getBranchCode(), 
      branchName: this.tokenStorageService.getBranchName(),ownerName: this.tokenStorageService.getOwnerName()}

    this.teacherDashService.saveUserData(userData).subscribe({
      next: (response: any) => {
        console.log(">>>saveUserData from service-Teacher: "+JSON.stringify(response)); 
        this.staffDetail =  response.data;            
      },
      error: (e) => {
        console.error(e);          
      }
    });
  }

  testMethod() {    
    console.log('>>>>>testMethod>>>>> ')
    let userName= Cookie.get('user_name')
    this.teacherDashService.testMethod(userName).subscribe({
      next: (data: any) => {
        console.log(">>>testdata from service: "+JSON.stringify(data)); 
        this.staffDetail =   data            
      },
      error: (e) => {
        console.error(e);          
      }
    });
  }
  
  /*getUserProfile() {    
    console.log('>>>>>getUserProfile>>>>> ')
    this.adminDashService.getUserProfile().subscribe({
      next: (data: any) => {
        console.log(">>>getUserProfile from service: "+JSON.stringify(data)); 
        this.userProfile =   data            
      },
      error: (e) => {
        console.error(e);          
      }
    });
  }
  getUserData(){
    console.log('>>>>>getUserData- sidebar-admin>>>>> ')
    this.adminDashService.getUserData().subscribe({
      next: (response: any) => {
        console.log(">>>getUserData from service:sidebar aadmin- "+JSON.stringify(response));
        if(response.status == environment.SUCCESS){
          this.userProfile =  response.data;
        }else{
          // Get from cookie beacuse it happens for first time
          const userData: User = {
            userName: this.tokenStorageService.getUser(),userRole: this.tokenStorageService.getUserRole(),
            clientName: this.tokenStorageService.getTenantName(), ownerName: this.tokenStorageService.getOwnerName()}
          
          this.userProfile = userData;
          //this.toastNotifyService.showErrorWithTimeout(response.message, "Notification", 7000);
        }           
      },
      error: (e) => {
        console.error(e);          
      }
    });
  }*/

}